import { render } from "./WorkMediaScratch.vue?vue&type=template&id=11c8855e"
import script from "./WorkMediaScratch.vue?vue&type=script&lang=js"
export * from "./WorkMediaScratch.vue?vue&type=script&lang=js"

import "./WorkMediaScratch.vue?vue&type=style&index=0&id=11c8855e&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__